import type { PeripheralPrinterSettings, PeripheralScaleSettings, PeripheralSatSettings } from './PeripheralSettings'
import type { SlimModel } from '~/domain/shared/slim/models/SlimModel'

export enum PeripheralType {
  Printer = 'printer',
  LabelPrinter = 'label_printer',
  Scale = 'scale',
  Sat = 'sat'
}

export interface PeripheralServer {
  ip: string
  port: number
}

export interface BasePeripheral extends SlimModel {
  type?: PeripheralType
  manufacturer?: string
  description?: string
  server?: PeripheralServer
}

export interface PrinterPeripheral extends BasePeripheral {
  type: PeripheralType.Printer | PeripheralType.LabelPrinter
  settings?: PeripheralPrinterSettings
}

export interface ScalePeripheral extends BasePeripheral {
  type: PeripheralType.Scale
  settings?: PeripheralScaleSettings
}

export interface SatPeripheral extends BasePeripheral {
  type: PeripheralType.Sat
  settings?: PeripheralSatSettings
}

export type Peripheral = PrinterPeripheral | ScalePeripheral | SatPeripheral
